/*global cb, $, location */
/*
User Interace Utility
Author: Christopher Polito

splitByKey
parseString
*/
import React from 'react';
import util from 'util';
import parse from 'html-react-parser';

const createString = (obj, _useKeys) => {
  //stringifies an object by key and value, used for creating object keys, optional omit keys

  let useKeys = _useKeys === false ? false : true;

  let stringArray = Object.entries(obj).map(([key, val]) => {
    return useKeys ? `${key}:${util.inspect(val)}` : `${util.inspect(val)}`;
  });

  return stringArray.join(';');
};

const parseString = (string) => {
  // this function parses a JSON string into a JSON object and returns that object
  // if the string is not a JSON string, the error is logged and an empty object is returned
  let itemObj;
  try {
    itemObj = JSON.parse(string);
  } catch (e) {
    console.log('error: string is not a JSON string: ', e);
    itemObj = {};
  }

  return itemObj;
};

const parseHtml = (htmlString) => {
  let unescapedHtml;

  try {
    unescapedHtml = typeof htmlString === 'string' ? <>{parse(htmlString)}</> : htmlString;
  } catch (e) {
    console.log('html parse error', e);
    unescapedHtml = htmlString;
  }

  return unescapedHtml;
};

let splitByKey = (args) => {
  /*
        this function splits an array of objects by changes in a value in the objects of that array
        the value is determined by the key passed in

        args : {items:[array], key:[type], rowCallback:[callback]-optional-, colCallback:[callback]-optional-}
        return two dimentional array of items split by args.key changes
            top = {
                items:[ ...{items:[ ...colItem ]} ]
            }
        used for displaying changes in uiType and orderId
    */

  let top = {};
  let temp = {};
  top.items = [];
  temp.items = [];
  let prevKey;
  let key = args.key;
  let rowCallback = args.rowCallback;
  let colCallback = args.colCallback;
  let rowIndex = 0;
  let colIndex = 0;

  let addRow = (temp, prevKey, array) => {
    colIndex = 0;
    //if optional callback exists use it to do any processing before pushing to the top level array
    if (typeof rowCallback == 'function') rowCallback(temp, array, prevKey, rowIndex++);
    // if not callback exists, just add it to the array
    else array.push(temp);
  };
  let addCol = (item, prevKey, array) => {
    // optional callback for processing before adding to array
    if (typeof colCallback == 'function') colCallback(item, array, prevKey, colIndex++);
    // if no callback exists, just add the item to the array
    else array.push(item);
  };

  args.items.forEach((item, index, array) => {
    if (prevKey && item[key] != prevKey) {
      // compare previous value with current value to determine an array split or not
      addRow(temp, prevKey, top.items); //add sub array to top level array
      // reset temp array
      temp = {};
      temp.items = [];
    }

    addCol(item, prevKey, temp.items); // add item to subarray
    prevKey = item[key]; // set previous value to be compared on next iteration

    if (index == array.length - 1) {
      addRow(temp, prevKey, top.items); //add last subarray to top level array
    }
  });

  return top;
};

const convertNaoUTCSavedOnToLocalDate = (utcSaveonDate) => {
  const dateOption = { year: 'numeric', month: '2-digit', day: '2-digit',
                   hour: '2-digit', minute: '2-digit', second: '2-digit'};
  let localDate = `${new Date(utcSaveonDate.slice((utcSaveonDate.indexOf("on") + 3))
                  .replace("at ", "").toUpperCase()
                  .concat(' ', 'UTC'))
                  .toLocaleString('en-US',dateOption)
                  .toLowerCase()}`
                  .replace(",", " at");
  return localDate;
}

export default {
  splitByKey,
  parseString,
  createString,
  parseHtml,
  convertNaoUTCSavedOnToLocalDate
};
